// extracted by mini-css-extract-plugin
export default {"addressAction":"X8-z","loading":"Y8-z"};